import styled from 'styled-components'

const Input = styled.input`
  flex: 1;
  min-width: 1rem;  // to allow flex to size
  margin: 0.3rem;
`

export default function NumberInput({ value, placeholder, onChange }) {
  // TODO: change to react-numeric-input?
  const keyDownHandler = (e) => {
    //console.log('NumberInput: keyPressHandler');
    //console.log(e.key + ' = ' + e.which);

    if ((e.which >= 48 && e.which <= 57)   ||    // numbers
  //    (e.which >= 65 && e.which <= 90)   ||    // letters
      (e.which >= 96 && e.which <= 105)  ||    // number pad
      (e.which === 13) || (e.which === 46) ||  // enter & delete
      (e.which === 35) || (e.which === 36) ||  // end & home
      (e.which === 8)  || (e.which === 9)  ||  // backspace & tab
      (e.which >= 37 && e.which <= 40))        // arrow keys
    {
      //console.log(e.which + ' is valid');
      return;

    } else {
      //console.log(e.key + ' is not valid');
      e.preventDefault();
    }
  }

  return (
    <Input
      type="text"
      value={value}
      placeholder={placeholder}
      autoFocus={true}
      onKeyDown={keyDownHandler}
      onChange={onChange}
      onFocus={(e) => {
        e.target.select();
      }}
     />
  );
}
